export const colors ={

    Present100: "#FFFFFF",
    Preterite100: "#FFFFFF",
    Imperfect100: "#FFFFFF",
    Future100: "#FFFFFF",
    Conditional100: "#FFFFFF",
    Pluperfect100: "#FFFFFF",
    Imperative100: "#FFFFFF",
    NegativeImperative100: "#FFFFFF",
    PresentPerfect100: "#FFFFFF",
    PreteritePerfect100: "#FFFFFF",
    FuturePerfect100: "#FFFFFF",
    ConditionalPerfect100: "#FFFFFF",

    Present90: "#81F8D0",
    Preterite90: "#CCE5FF",
    Imperfect90: "#FFE08D",
    Future90: "#FFD7EF",
    Conditional90: "#F9D8FF",
    Pluperfect90: "#C0F190",
    Imperative90: "#DBE1FF",
    NegativeImperative90: "#FFDAD6",
    PresentPerfect90: "#CEE9DC",
    PreteritePerfect90: "#D4E4F6",
    FuturePerfect90: "#FADAEC",
    ConditionalPerfect90: "#F2DCF3",

    Present80: "#64DBB4",
    Preterite80: "#EBC248",
    Imperfect80: "#FFD9E2",
    Future80: "#FFADE5",
    Conditional80: "#EDB1FF",
    Pluperfect80: "#A4D577",
    Imperative80: "#B4C5FF",
    NegativeImperative80: "#FFB4AB",
    PresentPerfect80: "#B2CCC0",
    PreteritePerfect80: "#B8C8DA",
    FuturePerfect80: "#DCBED0",
    ConditionalPerfect80: "#D5C0D7",

    Present40: "#006C53",
    Preterite40: "#006398",
    Imperfect40: "#745B00",
    Future40: "#953C81",
    Conditional40: "#9A00CD",
    Pluperfect40: "#406918",
    Imperative40: "#1755D1",
    NegativeImperative40: "#BA1A1A",
    PresentPerfect40: "#4C635A",
    PreteritePerfect40: "#51606F",
    FuturePerfect40: "#6F5767",
    ConditionalPerfect40: "#69596D",

    Present30: "#00513E",
    Preterite30: "#004B74",
    Imperfect30: "#584400",
    Future30: "#792368",
    Conditional30: "#75009D",
    Pluperfect30: "#2A5000",
    Imperative30: "#003EA7",
    NegativeImperative30: "#93000A",
    PresentPerfect30: "#344C42",
    PreteritePerfect30: "#394857",
    FuturePerfect30: "#56404F",
    ConditionalPerfect30: "#514254",

    Present20: "#00382A",
    Preterite20: "#003352",
    Imperfect20: "#3D2F00",
    Future20: "#5D054F",
    Conditional20: "#530070",
    Pluperfect20: "#1B3700",
    Imperative20: "#002A77",
    NegativeImperative20: "#690005",
    PresentPerfect20: "#1E352C",
    PreteritePerfect20: "#23323F",
    FuturePerfect20: "#3E2A38",
    ConditionalPerfect20: "#392C3D",

    Present10: "#002117",
    Preterite10: "#001D31",
    Imperfect10: "#241A00",
    Future10: "#3A0031",
    Conditional10: "#320046",
    Pluperfect10: "#0D2000",
    Imperative10: "#00174A",
    NegativeImperative10: "#410002",
    PresentPerfect10: "#082018",
    PreteritePerfect10: "#001D31",
    FuturePerfect10: "#281622",
    ConditionalPerfect10: "#241727",

    Purple80: "#D0BCFF",
    PurpleGrey80: "#CCC2DC",
    Pink80: "#EFB8C8",

    Purple40: "#6650A4",
    PurpleGrey40: "#625B71",
    Pink40: "#7D5260",
    DarkPink40: "#9D3C61",

    Blue10: "#001F29",
    DarkTeal10: "#081E27",
    DarkPurple10: "#191836",
    DarkPink10: "#3E001D",

    Green404: "#35fc3f30",
    Red404: "#d9000025",

    surfaceVariant: '#595e72',
    onSurfaceVariant: '#ffffff'

    
}
